import { ListKlassesFilters } from '@/data/services/klassServices';
import User from '@/models/User';
import TeachingWeekFilters from './TeachingWeekFilters';
import { isTeacher } from '@/functions/auth';
import { ClassNameComponent } from '@/utils/ClassNameComponent';

type TeachingWeekHeaderProps = {
  className?: ClassNameComponent;
  user: User;
  update(params: Partial<ListKlassesFilters>): void;
  filter: ListKlassesFilters;
};

export default function TeachingWeekHeader({
  user,
  update,
  filter,
}: TeachingWeekHeaderProps) {
  const teacherView = isTeacher(user.userType);

  return (
    <nav
      className={`flex w-full justify-start text-base-content flex-col 2xl:flex-row ${
        teacherView ? 'gap-0' : 'gap-5'
      }`}
    >
      <TeachingWeekFilters update={update} filter={filter} user={user} />
    </nav>
  );
}
